'use strict';

angular.module('TurneroApp').component('coAgendasConsulta', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        '$anchorScroll',
        '$scope',
        'agendaService',
        'TurneroAppConstant',
        '$rootScope',
        '$mdDialog',
        'utilsService',
        '$element',
    function ($anchorScroll, $scope, agendaService, TurneroAppConstant, $rootScope, $mdDialog, utilsService, $element) {
        var ctrl = this;

        ctrl.showfiltro = true;
        ctrl.Id_Agenda = 0;
        ctrl.focusBuscar = false;
        ctrl.lstAgendaHabilitada = '';

        ctrl.Modalidades = TurneroAppConstant.ModalidadesArray;
        ctrl.Agenda_Vigencia = TurneroAppConstant.Agenda_Vigencia;
        ctrl.VigenciaArray_Combo = TurneroAppConstant.Agenda_Vigencia_array;
        ctrl.Estados_Agenda = TurneroAppConstant.Estados.Agenda;
        ctrl.permisos = TurneroAppConstant.Permisos;
        ctrl.lstAgendaSeleccionadas = [];

        ctrl.$onInit = function () {
            ctrl.limpiarFiltro();
        }

        ctrl.$onChanges = function () {
            ctrl.centroAtencionSeleccionado.id && ctrl.getConsultaInfo();
        };

        ctrl.limpiarMemoria = function () {
            ctrl.Id_Agenda = null;
            ctrl.nuevaAgenda = false;
            ctrl.consultaAgenda = true;
            ctrl.agendaPaso1 = false;
            ctrl.agendaPaso2 = false;
            ctrl.agendaPaso3 = false;
            ctrl.agendaPaso4 = false;
            ctrl.agendaPaso5 = false;
            ctrl.agendaFinalizar = false;
            ctrl.agendaHistorial = false;
            ctrl.showfiltro = true;
            $anchorScroll();
        };

        ctrl.removeFilter = function () {
            ctrl.query.filter = '';
            ctrl.cargarGrilla();
            ctrl.filter = false;
        };

        ctrl.limpiarFiltro = function () {
            ctrl.query = {
                page: 1,
                limit: 10,
                filter: "",
                Id_Estado: "",
                Id_Tramite: "",
            };
        };

        ctrl.comenzarNuevaAgenda = function () {
            ctrl.nuevaAgenda = true;
            ctrl.consultaAgenda = false;
            ctrl.agendaPaso1 = false;
            ctrl.agendaPaso2 = false;
            ctrl.agendaPaso3 = false;
            ctrl.agendaPaso4 = false;
            ctrl.agendaPaso5 = false;
            ctrl.agendaFinalizar = false;
            ctrl.agendaHistorial = false;
        };

        ctrl.getConsultaInfo = function () {
            ctrl.loadFiltros();
            ctrl.limpiarMemoria();
            ctrl.cargarGrilla();
            ctrl.consultaBloqueo = true;
        };

        ctrl.query = {
            limit: 10,
            page: 1,
            filter: "",
            Id_Estado: "",
            Id_Tramite: "",
        };

        ctrl.limitOptions = [10, 25, 50, 75, 100, {
            label: 'Todos',
            value: function () {
                return ctrl.pagination.total;
            }
        }];

        //Se inicializa en null para que al principio no tome que no hay valores
        ctrl.pagination = {
            total: null
        };

        ctrl.inicializarAlta = function () {
            ctrl.limpiarMemoria();
            ctrl.loadAlta();
            ctrl.altaBloqueo = true;
        };

        ctrl.mostrarBuscar = function () {
            ctrl.filter = true;
            ctrl.focusBuscar = true;
        };

        ctrl.cargarGrilla = function () {
            ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
        };

        function cargarDatos(tipo, data) {
            if (tipo == 'grid') {
                ctrl.agendas_Consulta = data.Data;
                ctrl.pagination.total = data.Paging.Reg_Totales;
                ctrl.lstAgendaSeleccionadas = [];
            } else if (tipo == 'xls') {
                var arrayObject = data.Data;
                ctrl.arrayExport = [];
                ctrl.arrayExport[0] = [ctrl.centroAtencionSeleccionado.id, ctrl.centroAtencionSeleccionado.text];
                ctrl.arrayExport[1] = ['id', 'Nombre', 'Desde', 'Hasta', 'Modalidades', 'Estado'];
                for (var i = 0; i < arrayObject.length; i++) {
                    ctrl.arrayExport[i + 2] = [
                        arrayObject[i].Id_Agenda,
                        arrayObject[i].N_Agenda,
                        moment(arrayObject[i].Fec_Desde).toDate().toLocaleDateString(),
                        moment(arrayObject[i].Fec_Hasta).toDate().toLocaleDateString(),
                        arrayObject[i].Modalidades,
                        arrayObject[i].N_Estado,
                    ]
                }
                swal.close();
                ctrl.Excel.down([{
                    name: 'Agendas',
                    data: ctrl.arrayExport
                }]);
            }
        }

        ctrl.getData = function (page, limit, tipo, callback) {
            ctrl.promise = agendaService.GetListado({
                'filtro.Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id,
                'filtro.Id_Estado': ctrl.query.Id_Estado,
                'filtro.Id_Tramite': ctrl.query.Id_Tramite,
                'filtro.Texto': ctrl.query.filter,
                'filtro.Nro_Pagina': page,
                'filtro.Vigencia': ctrl.query.Vigencia,
                'filtro.Tam_Pagina': limit
            }).$promise.then(function (data) {
                callback(tipo, data);
                swal.close();
            }).catch(function (error) {
                utilsService.errores(error);
            });
        }

        ctrl.loadFiltros = function () {
            agendaService.GetFiltros({
                'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
            }).$promise.then(function (resultado) {
                ctrl.Filtros = resultado.Data
            }).catch(function (error) {
                utilsService.errores(error);
            })
        };

        ctrl.historialAgenda = function (Agenda) {
            ctrl.comenzarNuevaAgenda();
            ctrl.nuevaAgenda = false;
            ctrl.agendaHistorial = true;
            ctrl.agendaSeleccionada = Agenda;
        };

        ctrl.duplicarAgenda = function (item) {
            swal({
                title: 'Duplicar Agenda',
                html: 'Esta acción copiará todos los datos de la agenda <strong>' + item.N_Agenda + '</strong> en una nueva. ¿Desea continuar?',
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#004b81',
                cancelButtonColor: '#6E6969',
                cancelButtonText: 'No',
                confirmButtonText: 'Si',
                allowEscapeKey: false,
                allowOutsideClick: false
            }).then(function () {
                utilsService.swalNotification('Duplicando', '', 'info')
                agendaService.Duplicar({
                    'Id_Agenda': item.Id_Agenda
                }).$promise.then(function (resultado) {
                    swal.close();
                    swal({
                        title: 'Duplicación completada',
                        html: 'Se ha creado la agenda <strong>' + resultado.text + '</strong> . </br> Se abrirá el asistente para que pueda modificarla.',
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: 'OK',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function () {
                        swal.close();
                        ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                        agendaService.Get_Paso1({
                            'id_agenda': resultado.id
                        }, function (resultado) {
                            ctrl.modificarAgenda(resultado.Data);
                        })

                    })
                }).catch(function (error) {
                    utilsService.customError(error, 'error', 'No se puede duplicar la agenda');
                })
            })
        };

        ctrl.modificarAgenda = function (agenda) {
            ctrl.readOnly = false;
            ctrl.comenzarNuevaAgenda();
            ctrl.nuevaAgenda = false;
            ctrl.agendaPaso1 = true;
            var obj = {
                Agenda: agenda,
                Id_Agenda: agenda.Id_Agenda,
                isNew: agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente ? true : false
            }
            $rootScope.$broadcast('inicioAgendaPaso1_load', obj);
        };

        ctrl.visualizarAgenda = function (agenda) {
            ctrl.modificarAgenda(agenda);
            ctrl.readOnly = true;
        };

        ctrl.eliminarAgenda = function () {            
            let text = ctrl.lstAgendaSeleccionadas.length > 1 ? `Está por eliminar ${ctrl.lstAgendaSeleccionadas.length} agendas.` : `Está por eliminar la agenda ${ctrl.lstAgendaSeleccionadas[0].N_Agenda}.`;
            let ids = ctrl.GetId_AgendaConcat();

            swal({
                title: ctrl.lstAgendaSeleccionadas.length > 1 ? 'Eliminar Agendas' : 'Eliminar Agenda',
                html:  text + '¿Está seguro? </br></br> <div class="text-danger">Esta acción es irreversible.</div>',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#004b81',
                cancelButtonColor: '#d33',
                confirmButtonText: "Si, eliminarlo!",
                cancelButtonText: "No, cancelar!",
                allowEscapeKey: false,
                allowOutsideClick: false
            }).then(function () {
                let infoText = ctrl.lstAgendaSeleccionadas.length > 1 ? 'Eliminando agendas' : 'Eliminando agenda';
                utilsService.swalNotification('Procesando', infoText, 'info');

                agendaService.cambiarEstado({
                    'Id_Estado_Nuevo': TurneroAppConstant.Estados.Agenda.Eliminada
                }, ids).$promise.then(function (result) {
                    swal.close();                    
                    swal({
                        title: 'Eliminado!',
                        text: ctrl.lstAgendaSeleccionadas.length > 1 ? 'Las agendas fueron eliminadas correctamente' : 'La agenda ha sido eliminado correctamente',
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: 'Aceptar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function (result) {
                        ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
                    });
                }).catch(function (error) {
                    utilsService.errores(error);
                    ctrl.lstAgendaSeleccionadas = [];
                });
            });
        };

        ctrl.extenderAgendaModal = function () {

            ////abrir modal para que el usuario seleccione la fecha que desea extender.
            ctrl.agendaSeleccionada = ctrl.lstAgendaSeleccionadas.length > 1 ? {} : ctrl.lstAgendaSeleccionadas[0];

            let fechaMayor = ctrl.GetFechaMayor();

            //var fecha = moment(agenda.Fec_Hasta).add(1, 'days');
            var fecha = moment(fechaMayor).add(1, 'days').startOf('day');
            var fechahoy = moment(moment().locale('es')).startOf('day');
            ctrl.agendaSeleccionada.Fecha_Fin = fecha.toDate() >= fechahoy.toDate() ? fecha.toDate() : fechahoy.toDate();
            ctrl.agendaSeleccionada.nuevaFecha = fecha.toDate() >= fechahoy.toDate() ? fecha.toISOString() : fechahoy.toISOString();
            ctrl.agendaSeleccionada.N_Agenda = ctrl.lstAgendaSeleccionadas.length > 1 ? 'Varios seleccionados' : ctrl.lstAgendaSeleccionadas[0].N_Agenda;

            $mdDialog.show({
                template: require('./modalExtenderAgenda.html'),
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: false, // Only for -xs, -sm breakpoints.,
                controllerAs: '$ctrl',
                controller: function () {
                    return ctrl;
                }
            });
        };

        ctrl.GetFechaMayor = function () {
            let mayorFecha = moment(moment().locale('es')).startOf('day');
            let mayor = null;
            for (var i = 0; i < ctrl.lstAgendaSeleccionadas.length; i++) {
                let prev = i - 1;

                if (i === 0) {
                    mayorFecha = moment(ctrl.lstAgendaSeleccionadas[i].Fec_Hasta);
                    mayor = mayorFecha;
                } else {
                    let datePrev = moment(ctrl.lstAgendaSeleccionadas[prev].Fec_Hasta).startOf('day');
                    let dateCurrent = moment(ctrl.lstAgendaSeleccionadas[i].Fec_Hasta).startOf('day');

                    mayor = datePrev > dateCurrent ? datePrev : dateCurrent;
                    mayorFecha = mayorFecha > mayor ? mayorFecha : mayor;
                }
            }
            return mayorFecha;
        };

        ctrl.ExtenderFechaHasta = function (agenda) {

            if (moment(agenda.nuevaFecha).toDate() > moment(agenda.Fec_Hasta).toDate()) {
                let ids = ctrl.GetId_AgendaConcat();

                utilsService.swalNotification('Procesando', 'Extendiendo fecha de agenda : ' + agenda.N_Agenda, 'info')
                agendaService.Extender({
                    //'L_Id_Agenda': agenda.Id_Agenda,
                    'Fecha_Hasta': agenda.nuevaFecha
                }, ids).$promise.then(function (resultado) {
                    ctrl.cerrarModal();
               }).catch(function (error) {
                    swal.close();
                    utilsService.errores(error, null, ctrl.cerrarModal);
                });
            } else {
                swal({
                    title: 'Error en la nueva fecha hasta.',
                    text: 'La nueva fecha hasta no debe ser menor a la fecha hasta actual.',
                    type: 'error',
                    allowEscapeKey: false,
                    allowOutsideClick: false
                });
            }
        };

        ctrl.cerrarModal = function (isCancel = false) {
            ctrl.agendaSeleccionada = null;
            $mdDialog.destroy();

            if (isCancel) {
                return;
            }

            swal({
                text: 'Se ha extendido exitosamente la fecha de la agenda.',
                type: 'success',
                confirmButtonColor: '#004b81',
                confirmButtonText: 'Aceptar',
                allowEscapeKey: false,
                allowOutsideClick: false
            }).then(function () {
                ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
            });
        };

        ctrl.GetId_AgendaConcat = function () {
            let ids = [];
            ctrl.lstAgendaSeleccionadas.forEach(function (valor, i, lst) {
                ids.push(valor.Id_Agenda);
            });
            return ids;
        }

        ctrl.habilitarAgenda = function () {

            let ids = ctrl.GetId_AgendaConcat();
            let catAgendas = ctrl.lstAgendaSeleccionadas.length;

            if (ctrl.lstAgendaHabilitada == 'Habilitada') {
                swal({
                    title: catAgendas > 1 ? '¿Inhabilitar agendas?' : '¿Inhabilitar agenda?',
                    html: catAgendas > 1 ? `¿Desea inhabilitar ${catAgendas} agendas?` : '¿Desea inhabilitar la agenda "' + ctrl.lstAgendaSeleccionadas[0].N_Agenda + '"?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#e77a1e',
                    cancelButtonColor: '#AAA5A5',
                    confirmButtonText: '¡Sí, inhabilitarla!',
                    cancelButtonText: 'No, cancelar',
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then(function () {
                    let infoText = catAgendas > 1 ? `Cambiando estado de ${catAgendas} agendas` : `Cambiando estado de agenda ${ctrl.lstAgendaSeleccionadas[0].N_Agenda}`;
                    utilsService.swalNotification('Procesando', infoText, 'info')
                    agendaService.cambiarEstado({
                        //'L_Id_Agenda': ids,
                        'Id_Estado_Nuevo': TurneroAppConstant.Estados.Agenda.Inhabilitada
                    }, ids).$promise.then(function (result) {
                        swal.close();
                        ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                        swal({
                            title: '¡Inhabilitada!',
                            text: 'Se ha inhabilitado la agenda.',
                            type: 'success',
                            confirmButtonColor: '#004b81',
                            confirmButtonText: 'Aceptar',
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then(function (result) {
                            ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
                        });
                    }).catch(function (error) {
                        utilsService.errores(error);
                        ctrl.lstAgendaSeleccionadas = [];
                    })
                })
            } else if (ctrl.lstAgendaHabilitada == 'Inhabilitada') {
                swal({
                    title: catAgendas > 1 ? '¿Habilitar agendas?' : '¿Habilitar agenda?',
                    html: catAgendas > 1 ? `¿Desea habilitar ${catAgendas} agendas?'` : '¿Desea habilitar la agenda "' + ctrl.lstAgendaSeleccionadas[0].N_Agenda + '"?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#e77a1e',
                    cancelButtonColor: '#AAA5A5',
                    confirmButtonText: '¡Sí, habilitarla!',
                    cancelButtonText: 'No, cancelar',
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then(function () {
                    let infoText = catAgendas > 1 ? `Cambiando el estado de ${catAgendas} agendas` : `Cambiando estado de agenda: ${ctrl.lstAgendaSeleccionadas[0].N_Agenda}`
                    utilsService.swalNotification('Procesando', infoText, 'info')
                    agendaService.cambiarEstado({
                        //'L_Id_Agenda': ids,
                        'Id_Estado_Nuevo': TurneroAppConstant.Estados.Agenda.Habilitada
                    }, ids).$promise.then(function (result) {

                        swal.close();

                        if (result.Data && result.Data.length > 0) {
                            swal({
                                title: 'Tramites repetidos',
                                html: "Uno de los trámites ya existe online para otra agenda. Presione aceptar si desea exportar el listado a excel.",
                                type: 'info',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: 'Aceptar',
                                showCancelButton: true,
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                cancelButtonColor: '#971b2f',
                                cancelButtonText: 'Cancelar'
                            }).then(function (respuesta) {
                                if (respuesta === true) {
                                    exportarExcel(result.Data);
                                }

                            })
                        } else {

                            swal({
                                title: '¡Habilitada!',
                                text: 'Se ha habilitado la agenda.',
                                type: 'success',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: 'Aceptar',
                                allowEscapeKey: false,
                                allowOutsideClick: false
                            }).then(function (result) {
                                ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
                            });
                        }
                    }).catch(function (error) {
                        utilsService.errores(error);
                        ctrl.lstAgendaSeleccionadas = [];
                    })
                })
            }
        };

        ctrl.DisabledAction = function () {
            for (var i = 0; i < ctrl.lstAgendaSeleccionadas.length; i++) {
                var prev = i === 0 ? i : i - 1;

                if (ctrl.lstAgendaSeleccionadas[i].N_Estado != 'Habilitada' && ctrl.lstAgendaSeleccionadas[i].N_Estado != 'Inhabilitada') {
                    ctrl.lstAgendaHabilitada = '';
                    return true;
                }

                if (ctrl.lstAgendaSeleccionadas[prev].N_Estado !== ctrl.lstAgendaSeleccionadas[i].N_Estado) {
                    ctrl.lstAgendaHabilitada = '';
                    return true;
                }
            }

            if (ctrl.lstAgendaSeleccionadas.length > 0 && (ctrl.lstAgendaSeleccionadas[0].N_Estado === 'Habilitada' || ctrl.lstAgendaSeleccionadas[0].N_Estado === 'Inhabilitada')) {
                ctrl.lstAgendaHabilitada = ctrl.lstAgendaSeleccionadas[0].N_Estado;
            }
            return false;
        };

        ctrl.validarModalidad = function (item, modalidad) {
            var array = item.Modalidades.split(',');
            for (var i = 0; i < array.length; i++) {
                if (modalidad == array[i]) {
                    return true;
                }
                if (modalidad == TurneroAppConstant.ModalidadesArray.Atencion_Telefonica.Text) {
                    var arrayValue = array[i].replace(/ó/gi, "o");
                    if (modalidad.toUpperCase() == arrayValue.toUpperCase()) return true;
                }
            }
            return false;
        };

        //VER CONSULTA AGENDA
        ctrl.consultaAgendas = function (bool) {
            if (bool) {
                ctrl.limpiarMemoria();
                ctrl.Id_Agenda = null;
                ctrl.cargarGrilla();
            }
        }

        //MOSTRAR MENSAJE FINAL
        ctrl.mostrarMensajeFinal = function () {
            var action = ctrl.lstAgendaSeleccionadas.length > 0 ? "modificó" : "creo";
            swal({
                title: 'Guardado',
                text: `La agenda se ${action} exitosamente!`,
                type: 'success',
                confirmButtonColor: '#004b81',
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'OK'
            }).then(function () {
                swal.close();
                ctrl.consultaAgendas(true);
            });
        }

        //VER AGENDA : PASO 1
        ctrl.inicioAgendaPaso1 = function (bool, isNew, Id_Agenda) {
            ctrl.comenzarNuevaAgenda();
            ctrl.nuevaAgenda = !bool;
            ctrl.agendaPaso1 = bool;

            var obj = {
                Id_Agenda: Id_Agenda,
                isNew: isNew
            }
            $rootScope.$broadcast('inicioAgendaPaso1_load', obj);
        }

        //VER AGENDA : PASO 2
        ctrl.inicioAgendaPaso2 = function (bool, isNew, Id_Agenda) {
            ctrl.comenzarNuevaAgenda();
            ctrl.nuevaAgenda = !bool;
            ctrl.agendaPaso2 = bool;

            var obj = {
                Id_Agenda: Id_Agenda,
                isNew: isNew
            }
            $rootScope.$broadcast('inicioAgendaPaso2_load', obj);
        };

        //VER AGENDA : PASO 3
        ctrl.inicioAgendaPaso3 = function (bool, isNew, Id_Agenda) {
            ctrl.comenzarNuevaAgenda();
            ctrl.nuevaAgenda = !bool;
            ctrl.agendaPaso3 = bool;

            var obj = {
                Id_Agenda: Id_Agenda,
                isNew: isNew
            }
            $rootScope.$broadcast('inicioAgendaPaso3_load', obj);
        };

        //VER AGENDA : PASO 4
        ctrl.inicioAgendaPaso4 = function (bool, isNew, Id_Agenda) {
            ctrl.comenzarNuevaAgenda();
            ctrl.nuevaAgenda = !bool;
            ctrl.agendaPaso4 = bool;
            var obj = {
                Id_Agenda: Id_Agenda,
                isNew: isNew
            }
            $rootScope.$broadcast('inicioAgendaPaso4_load', obj);

        };

        //VER AGENDA : PASO 5
        ctrl.inicioAgendaPaso5 = function (bool, isNew, Id_Agenda) {
            ctrl.comenzarNuevaAgenda();
            ctrl.nuevaAgenda = !bool;
            ctrl.agendaPaso5 = bool;
            var obj = {
                Id_Agenda: Id_Agenda,
                isNew: isNew
            }
            $rootScope.$broadcast('inicioAgendaPaso5_load', obj);
        };

        //VER AGENDA : PASO FINALIZAR
        ctrl.finalizarAgenda = function (bool) {
            ctrl.comenzarNuevaAgenda();
            ctrl.nuevaAgenda = !bool;
            ctrl.agendaFinalizar = bool;
        };

        //EXPORTAR A EXCEL
        ctrl.isOpen = false;
        ctrl.selectedMode = 'md-fling';
        ctrl.selectedDirection = 'up';
        ctrl.exportar = function (tipo) {
            utilsService.swalTitle('Exportando datos', 'info')
            ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos);
        }

        ctrl.Excel = {
            down: function () {
            },
        }


        $element.find('input').on('keydown', function (ev) {
            ctrl.searchTerm = ctrl.searchTerm
            ev.stopPropagation();
        });

        ctrl.searchTerm = {
            text: ''
        };
        ctrl.clearSearchTerm = function () {
            ctrl.searchTerm = {
                text: ''
            };
        };

        function exportarExcel(data) {
            var arrayObject = data;
            ctrl.arrayExport = [];
            ctrl.arrayExport[1] = ['Número y Nombre de Tramite', 'Número y Nombre de Agenda'];
            for (var i = 0; i < arrayObject.length; i++) {
                var index = ctrl.arrayExport.length;
                ctrl.arrayExport[ctrl.arrayExport.length] = [arrayObject[i].Tramite, arrayObject[i].Agendas[0]];
                for (var j = 1; j < arrayObject[i].Agendas.length; j++) {
                    ctrl.arrayExport[ctrl.arrayExport.length] = [' ', arrayObject[i].Agendas[j]];
                }

            }
            swal.close();
            ctrl.ExcelTramites.down([{
                name: 'Tramites_Repetidos',
                data: ctrl.arrayExport
            }]);

        }
        ctrl.ExcelTramites = {
            down: function () {
            },
        }

    }],
    template: require('./agendaConsulta.html')
});




// WEBPACK FOOTER //
// ./app/components/agenda/agendaConsultaComponent.js